<nav
  class="bp-sdk-question-set-navigation__container .emperor-ui-navigation__container"
  aria-label="Question Sets"
  role="navigation"
  onKeyDown="{this.onKeyDown}"
  onKeyUp="{this.onKeyUp}"
>
  <emperor-timeline [steps]="(timelineSteps$ | async)!"></emperor-timeline>
</nav>
